import axios from 'axios'
import storage from './storage'

const ns = {}

/** 账户----------------------------- */
// 判断当前accessToken是否仍然有效
ns.isLogin = async function() {
  const res = await axios({
    url: `/v1/is_login`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

// 获取短信验证码
ns.getSmsCode = async function (params) {
  await axios.post('/v1/smscode', {
    mobilePhone: params.mobilePhone
  })
}

// 获取重置密码短信验证码
ns.getResetPasswordSmsCode = async function (params) {
  await axios.post('/v1/smscode', {
    mobilePhone: params.mobilePhone,
    smsCodeType: 'reset_password'
  })
}

// 重置密码
ns.resetPassword = async function (mobilePhone, password, smsCode) {
  const res = await axios.post('/v1/reset_password', {
    mobilePhone,
    password,
    smsCode
  })
  return res.data
}

// 注册用户
ns.signup = async function (params) {
  const res = await axios.post('/v1/signup', {
    mobilePhone: params.mobilePhone,
    smsCode: params.smsCode,
    fullName: params.fullName,
    password: params.password
  })
  return res.data
}

// 登录
ns.login = async function (params) {
  const res = await axios.post('/v1/login', {
    mobilePhone: params.mobilePhone,
    password: params.password
  })
  return res.data
}

// 登录
ns.login_sms = async function (params) {
  const res = await axios.post('/v1/login_sms', {
    mobilePhone: params.mobilePhone,
    smsCode: params.smsCode
  })
  return res.data
}

// 退出登录
ns.logout = async function (params) {
  const res = await axios({
    url: '/v1/logout',
    method: 'post',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })
  return res.data
}

// 根据手机查找用户
ns.searchUser = async function(mobilePhone) {
  const res = await axios({
    url: `/v1/user?mobilePhone=${mobilePhone}`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

// 获取用户详情
ns.getUserInfo = async function(userId) {
  const res = await axios({
    url: `/v1/user/${userId}`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

// 获取当前用户
ns.getCurrentUser = async function() {
  const res = await axios({
    url: `/v1/current_user`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

// 更新用户信息
ns.updateUserInfo = async function(userId, params) {
  const updateData = {}
  if (params.fullName) updateData.fullName = params.fullName
  if (params.password) updateData.password = params.password
  if (params.avatar) updateData.avatar = params.avatar

  const res = await axios({
    url: `/v1/user/${userId}`,
    method: 'PUT',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }, 
    data: updateData
  })

  return res.data
}

/** 群相关------------------------------- */
// 创建群
ns.createGroup = async function (params) {
  const res = await axios({
    url: '/v1/group',
    method: 'post',
    data: {
      name: params.name
    },
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })
  return res
}

// 获取群详情
ns.getGroupDetail = async function (groupId) {
  const res = await axios({
    url: `/v1/group/${groupId}`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

// 用邀请码加入群
ns.joinGroupWithInviteCode = async function(inviteCode, groupId) {
  const res = await axios({
    url: `/v1/group/${groupId}/join_group`,
    method: 'POST',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    data: {
      inviteCode
    }
  })

  return res.data
}

// 判断邀请码是否有效
ns.isInviteCodeValid = async function(inviteCode, groupId) {
  const res = await axios({
    url: `/v1/group/${groupId}/check_invite_code`,
    method: 'POST',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    data: {
      inviteCode
    }
  })

  return res.data
}

// 生成新的邀请码
ns.generateInviteCode = async function(groupId) {
  const res = await axios({
    url: `/v1/group/${groupId}/invite_code`,
    method: 'POST',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

// 判断用户是否是群成员
ns.isGroupMember = async function(groupId) {
  const res = await axios({
    url: `/v1/is_group_member?groupId=${groupId}`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

// 用户加入的群
ns.getJoinedGroups = async function (userId) {
  const res = await axios({
    url: `/v1/user/${userId}/joined_groups`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })
  return res.data
}

// 群的相册列表
ns.getGroupAlbums = async function (groupId) {
  const res = await axios({
    url: `/v1/group/${groupId}/album`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

// 添加用户到群
ns.addUserToGroup = async function (groupId, userId) {
  const res = await axios({
    url: `/v1/group/${groupId}/member`,
    method: 'POST',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    data: {
      groupId,
      userId
    }
  })

  return res.data
}

// 添加用户到群
ns.noUseraddUserToGroup = async function (mobilePhone, groupId) {
  const res = await axios({
    url: `/v1/group/group_phone`,
    method: 'POST',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    data: {
      groupId,
      mobilePhone
    }
  })

  return res.data
}

// 把用户移除群
ns.removeUserFromGroup = async function(groupId, memberId) {
  const res = await axios({
    url: `/v1/group/${groupId}/member/${memberId}`,
    method: 'DELETE',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

// 把未注册用户移除群
ns.removeUserFromNoUserGroup = async function(id) {
  const res = await axios({
    url: `/v1/group/group_phone/${id}`,
    method: 'DELETE',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}
// 退出群
ns.quitGroup = async function(groupId) {
  const res = await axios({
    url: `/v1/group/${groupId}/quit_group`,
    method: 'POST',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    data: {
      groupId
    }
  })

  return res.data
}

// 获取群成员列表
ns.getGroupMembers = async function (groupId) {
  const res = await axios({
    url: `/v1/group/${groupId}/member`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}


// 获取未注册群成员列表
ns.getGroupNoUsers = async function (groupId) {
  const res = await axios({
    url: `/v1/group/group_phone/${groupId}`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

// 编辑群
ns.updateGroup = async function (groupId, params) {
  const updateData = {}
  if (params.name) updateData.name = params.name
  if (params.coverpage) updateData.coverpage = params.coverpage
  if (params.avatar) updateData.avatar = params.avatar
  if (params.inviteCode) updateData.inviteCode = params.inviteCode
  if (params.enableInviteCode !== undefined && params.enableInviteCode !== null) {
    updateData.enableInviteCode = params.enableInviteCode
  }
  const res = await axios({
    url: `/v1/group/${groupId}`,
    method: 'PUT',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    data: updateData
  })

  return res.data
}

/** 相册相关------------------------------- */
// 创建相册
ns.createAlbum = async function (groupId, params) {
  const res = await axios({
    url: `/v1/group/${groupId}/album`,
    method: 'POST',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    data: {
      name: params.name,
      coverpage: params.coverpage
    }
  })
  return res.data
}

// 获取相册信息
ns.getAlbumInfo = async function (groupId, albumId) {
  const res = await axios({
    url: `/v1/group/${groupId}/album/${albumId}`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })
  return res.data
}

ns.updateAlbum = async function (groupId, albumId, params) {
  const res = await axios({
    url: `/v1/group/${groupId}/album/${albumId}`,
    method: 'PUT',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    data: {
      name: params.name
    }
  })
  return res.data
}

// 相册中的照片列表
ns.getAlbumPhotos = async function (params) {
  const res = await axios({
    url: `/v1/group/${params.groupId}/album/${params.albumId}/photo`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    params: {
      pageSize: params.pageSize,
      pageId: params.pageId
    }
  })

  return res.data
}

// 上传文件到服务器
ns.uploadFile = async function(formData) {
  const res = await axios({
    url: `/v1/file`,
    method: 'POST',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    data: formData
  })

  return res.data
}

// 添加照片到相册
ns.addPhotoToAlbum = async function(groupId, albumId, params) {
  const res = await axios({
    url: `/v1/group/${groupId}/album/${albumId}/photo`,
    method: 'POST',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    data: {
      photoPath: params.photoPath,
      fileName: params.fileName,
      fileSize: params.fileSize,
      fileType: params.fileType
    }
  })

  return res.data
}

/** 照片相关--------------------------- */
ns.getPhotoInfo = async function(groupId, albumId, photoId) {
  const res = await axios({
    url: `/v1/group/${groupId}/album/${albumId}/photo/${photoId}`,
    method: 'GET',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

// 删除照片
ns.delPhoto = async function(groupId, albumId, photoId) {
  const res = await axios({
    url: `/v1/group/${groupId}/album/${albumId}/photo/${photoId}`,
    method: 'DELETE',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    }
  })

  return res.data
}

ns.likePhoto = async function(params) {
  const res = await axios({
    url: `/v1/photo/${params.photoId}`,
    method: 'POST',
    headers: {
      'Authorization': `Bear ${storage.getAccessToken()}`
    },
    data: {
      groupId: params.groupId,
      albumId: params.albumId
    }
  })

  return res.data
}

export default ns
